// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_username_username_module_ts":"cfcd96c5c157bb67","node_modules_dompurify_dist_purify_es_mjs":"a6d13573764d2389","node_modules_canvg_lib_index_es_js":"49c6afb346bf4082"}[chunkId] + ".js";
};